<template>
    <v-row class="mt-10 pt-16 mx-0" :class="$vuetify.breakpoint.mobile ? 'px-5' : 'px-16'">
        <v-col cols="12" lg="3">
            <filters-component v-if="!$vuetify.breakpoint.mobile" @fetchProjects="fetch = true" :language="language" :available="available" :loading="fetch"/>
            <v-btn v-else color="#FF5252" dark @click="dialog = !dialog">
                {{language=='Ελληνικά'? 'ΦΙΛΤΡΑ' : 'FILTERS'}}
                <v-icon>
                    mdi-tune
                </v-icon>
            </v-btn>
        </v-col>
        <v-dialog
            v-if="$vuetify.breakpoint.mobile"
            v-model="dialog"
            fullscreen
            transition="dialog-bottom-transition"
            class="mx-0"
        >
            <v-card class="mx-16">
                <v-toolbar
                    color="black"
                    flat
                    class="rounded-0"
                >
                    <v-btn
                        icon
                        @click="dialog = false"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-row no-gutters>
                    <v-col cols=12 class="px-10 pt-10">
                        <filters-component @fetchProjects="fetch = true" :language="language" :available="available" :loading="fetch"/>
                    </v-col>
                </v-row>
            </v-card>
        </v-dialog>
        <v-col cols="12" lg="9">
            <project-component :fetch="fetch" @setFetch="fetch = false; dialog = false" :language="language" :available="available"/>
        </v-col>
    </v-row>
</template>

<script>
import ProjectComponent from '@/components/ProjectComponent.vue'
import FiltersComponent from '@/components/FiltersComponent.vue'

export default {
  components: { ProjectComponent, FiltersComponent },
  props: {
        language: String
  },
  data() {
        return {
            fetch: false,
            dialog: false
        }
    },
    created() {
    }
}
</script>

<style lang="scss" scoped>
    .v-sheet {
        background: white !important;
    }

    .projects-nav{
        width:100%;
    }

    @media only screen and (min-width: 600px){
        .projects-nav {
            padding:5% 0% 0% 5%;
        }

    }
    @media only screen and (max-width: 600px){
        .projects-nav {
            padding:15% 10% 10% 10%;
        }
    }

</style>